import Instrument from '@javascript/habitual-analytics/models/instrument/index';
import moment from 'moment';
import { OptionTypes, Segments } from '@javascript/habitual-analytics/brokers/OrderFacade/types/common';
import _ from 'lodash';
import { InstrumentModel } from '@javascript/habitual-analytics/models/instrument/types';
import {
  TradingSymbol,
  FutureTradingSymbol, OptionTradingSymbol
} from '@javascript/habitual-analytics/brokers/OrderFacade/types/TradingSymbol';

export const ParseTradingSymbol = (tradingSymbolObject: TradingSymbol): InstrumentModel => {
  if (tradingSymbolObject.segment === Segments.FUT
    || tradingSymbolObject.segment === Segments.OPT) {
    return parseFNOInstrument(tradingSymbolObject);
  }
  return new Instrument({
    symbol: _.get(tradingSymbolObject, 'instrument', ''),
    expiryDate: undefined,
    strikePrice: undefined,
    optionType: undefined
  });
};

const parseFNOInstrument = (
  tradingSymbolObject: FutureTradingSymbol | OptionTradingSymbol
): InstrumentModel => {
  const { expiry } = tradingSymbolObject;
  const isFuture = tradingSymbolObject.segment === Segments.FUT;

  const getExpiry = moment({
    year: expiry.year,
    month: expiry.month - 1,
    day: expiry.date,
  }).format('YYYY-MM-DD');

  return new Instrument({
    symbol: _.get(tradingSymbolObject, 'instrument', ''),
    expiryDate: getExpiry,
    strikePrice: isFuture
      ? undefined : _.get(tradingSymbolObject, 'strikePrice', ''),
    optionType: isFuture
      ? undefined : _.get(tradingSymbolObject, 'optionType', OptionTypes.CE)
  });
};